module.exports = __webpack_public_path__ + "static/defipulse-logo-a91e2e402cb49539575d9c6f8ee705b7.jpg";